var map = {
	"./74_stars.mp3": "5a54",
	"./82_ham.mp3": "4c60",
	"./83_Easter_eggs.mp3": "5c0e",
	"./84_decorate.mp3": "f13e",
	"./85_chocolate.mp3": "8178",
	"./86_Easter_bunny.mp3": "ee96",
	"./M_Brilliant.mp3": "ce1a",
	"./M_Excellent.mp3": "6d481",
	"./M_Fantastic.mp3": "edc5",
	"./M_Great.mp3": "9a7f",
	"./M_Perfect.mp3": "c0e4",
	"./M_Think again.mp3": "5dac",
	"./M_Try again.mp3": "d0c5",
	"./M_Very good.mp3": "abb3",
	"./M_Well done.mp3": "e1a4",
	"./M_Work harder.mp3": "58a0",
	"./click.mp3": "6596",
	"./false.mp3": "9d8e",
	"./true.mp3": "014b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "833e";